export const userPoolId = 'us-west-2_rPFjdIr03';

export const clientId = '2nv7rlvektdfs07fu77dmf7fd0'

export const identityPoolId = "us-west-2:4aa9582f-6cff-437b-982c-178e6168d3fd";

export const apiURL = "https://test-api.correlator.aip.corrprocanada.com/adc/"